export default function(){var e={};return e.promise=new Promise((function(r,n){e.resolve=r,e.reject=n})),e}
